import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { iconAttributes } from '@/utils/icons';


export default /*@__PURE__*/_defineComponent({
  __name: 'LangRu',
  setup(__props) {

const attrs = iconAttributes({ width: 20, height: 20 });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _normalizeProps(_guardReactiveProps(_unref(attrs))), _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_19906_33791)" }, [
      _createElementVNode("rect", {
        width: "20",
        height: "6",
        transform: "matrix(-1 0 0 1 20 0)",
        fill: "#F7FCFF"
      }),
      _createElementVNode("rect", {
        width: "20",
        height: "8",
        transform: "matrix(-1 0 0 1 20 6)",
        fill: "#0052B4"
      }),
      _createElementVNode("rect", {
        width: "20",
        height: "6",
        transform: "matrix(-1 0 0 1 20 14)",
        fill: "#D80027"
      })
    ], -1)
  ]), 16))
}
}

})